import { LoansByStatusLinksList } from './LoansByStatusLinksList';

export default LoansByStatusLinksList;
